import { createSelector } from 'reselect';
import { getOffline } from './getOffline';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getConnection } from './getConnection';
import { getStatusStartAt } from './getStatusStartAt';

export const getMachineHeaderTime = createSelector(
  [
    getOffline,
    getUnavailableStartAt,
    getFaultStartAt,
    getConnection,
    getStatusStartAt,
  ],
  (
    offline,
    unavailableStartAt,
    faultStartAt,
    { disconnectedAt },
    statusStartAt
  ) => {
    return (
      (offline && disconnectedAt) ||
      unavailableStartAt ||
      faultStartAt ||
      statusStartAt
    );
  }
);
